module.exports = __webpack_public_path__ + "img/pic_12.9200ea04.jpg";